<template>
  <div>
    <div v-show="false">
      <Player
        ref="player"
        v-on:video="updateMediaState"
        :url="mediaSrc"
        :subtitles="data"
        :playAt="currentSentIdx" />
    </div>

    <div id="recorder" class="p-2">
      <div class="d-flex justify-content-start p-2">
        <div>
          <button class="btn"
            @click="playMyRoles()"
            v-if="!(isRecordSingle || isRecordAll || playMine || media.state === 'playing')">
            <img src="../assets/images/icon_play.png" height="35" />
          </button>

          <button class="btn"
            @click="stopAll()"
            v-else>
            <img src="../assets/images/icon_pause.png" height="35" />
          </button>

          <span style="vertical-align: middle;">{{ recordStatus }}</span>
        </div>

        <div class="ml-auto">
          <button class="btn"
            v-bind:class="{ 'active': isRecordSingle }"
            @click="isRecordSingle = true; recordStatus = '請選擇句子'">
            <img src="../assets/images/icon_1_avatar.png" /> 單句
          </button>

          <button class="btn"
            v-bind:class="{ 'active': isRecordAll && userRole === null }"
            @click="recordAll()">
            <img src="../assets/images/icon_2_avatar.png" /> 全部
          </button>

          <popper ref="rolePopper" trigger="click"
            :options="{ placement: 'bottom' }"
            v-if="roles && roles.length > 1">
            <div class="popper">
              <button class="btn"
                v-bind:class="{ 'active': isRecordAll && userRole === role }"
                v-for="role in roles" :key="role"
                @click="$refs.rolePopper.doClose() || recordAll(role)">
                  <img src="../assets/images/icon_1_avatar.png" /> <span v-html="role"></span>
              </button>
            </div>

            <button slot="reference" class="btn"
              v-bind:class="{ 'active': isRecordAll && userRole }">
              <img src="../assets/images/icon_1_avatar.png" /> <span v-html="(isRecordAll && userRole) ? userRole : '角色扮演'"></span>
            </button>
          </popper>
        </div>
      </div>
    </div>

    <div class="panel">
      <Sentences :texts="data"
        :lang="['en_us']"
        :currentTime="media.currentTime"
        v-on:selectSentId="singleSent">
          <template slot="leftside" slot-scope="props">
            <span v-if="props.row.no === (currentSentIdx + 1)">
              <i class="fa fa-microphone blink" v-if="recording"></i>
              <i class="fa fa-play-circle blink" v-if="media && media.state === 'playing'"></i>
            </span>
          </template>

          <template slot="rightside" slot-scope="props">
            <span class="btn" style="font-size: 8px;"
              @click="playRecord(props.row.no - 1)"
              v-if="audioList.map((e) => { return e.name }).indexOf(props.row.text) > -1">
              <img src="../assets/images/icon_headphone_on.png"
                v-bind:class="{
                  'blink' : props.row.no === (media.currentSentIdx + 1) && (audio && !audio.paused)
                }"
                v-if="props.row.no === (media.currentSentIdx + 1) && (audio && !audio.paused)" />
              <img src="../assets/images/icon_headphone_off.png" v-else />
              <br />
              {{ moment(audioList[audioList.map((e) => { return e.name }).indexOf(props.row.text)].createtime).fromNow() }}
            </span>
          </template>
      </Sentences>
    </div>

    <div class="mt-2">
      <slot name="left"></slot>
    </div>
  </div>
</template>

<script>
  import api from '../api.js'
  import './modules/recorder.js'
  import moment from 'moment'
  import 'moment-duration-format'
  import Player from './modules/MiniPlayer.vue'
  import Sentences from './modules/Sentences.vue'
  import MobileDetect from 'mobile-detect'
  import Popper from 'vue-popperjs'
  import 'vue-popperjs/dist/css/vue-popper.css'
  import swal from 'bootstrap-sweetalert'
  import 'bootstrap-sweetalert/dist/sweetalert.css'

  export default {

    name: 'Recorder',

    props: {
      mediaSrc: {
        type: String,
        required: true,
        default: ''
      },

      data: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      }
    },

    components: {
      Player,
      Sentences,
      Popper
    },

    data () {
      return {
        audioUrl: null,
        recorder: null,
        recording: false,
        playing: false,
        timer: 0,
        countDownTimer: 0,
        media: {},
        recordStatus: '',
        audioList: [],
        currentSentIdx: -1,
        isRecordAll: false,
        isRecordSingle: false,
        roles: [],
        playMine: false,
        userRole: null,
        fontSize: 's',
        audio: null
      }
    },

    created () {
      let md = new MobileDetect(window.navigator.userAgent)
      // window.console.log(this.$parent.lesson.id, md, md.os(), md.mobile())
      if (md.os() === 'AndroidOS' || md.os() === 'iOS') {
        let link = 'livelearning://?LessonId=' + this.$parent.lesson.id + '&token=' + window.localStorage.getItem('token')
        let appStoreLink = 'https://itunes.apple.com/tw/app/live-speaking/id1282239139?l=zh&ls=1&mt=8'
        let googlePlayLinke = 'https://play.google.com/store/apps/details?id=com.LiveABC.LiveSpeaking'
        let fallback = (md.os() === 'iOS') ? appStoreLink : googlePlayLinke

        window.open(link)
        setTimeout(function () {
          window.open(fallback, '_blank', '')
        }, 300)
      }

      let requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.msRequestAnimationFrame

      window.requestAnimationFrame = requestAnimationFrame
    },

    mounted () {
      this.getRoles()
      // 取得線上錄音存擋
      // let self = this
      // if (!this.$parent.isDemo) {
      //   api.Lesson.ErsData(this.$parent.modules.id)
      //     .then((res) => {
      //       res.data.data.forEach((audio) => {
      //         self.audioList.push({
      //           id: audio.id,
      //           name: audio.text,
      //           createtime: audio.createTime
      //         })
      //       })
      //     })
      // }
    },

    methods: {
      getRoles () {
        this.data.forEach((sent) => {
          if (sent.name !== '' && this.roles.indexOf(sent.name) === -1) {
            this.roles.push(sent.name)
          }
        })
      },

      duration: function (seconds) {
        return moment.duration(seconds, 'minutes')
          .format('hh:mm', { trim: false })
      },

      moment: function (str) {
        moment.locale('zh-tw')
        return moment(str)
      },

      startTimer () {
        let self = this
        // let seconds = 0
        let start = null
        let step = (timestamp) => {
          let progress

          if (start === null) {
            start = timestamp
          }

          progress = timestamp - start

          self.timer = Math.round(progress / 1000)

          if (self.recording === true) {
            window.requestAnimationFrame(step)
          }
        }

        window.requestAnimationFrame(step)
      },

      startRecording () {
        if (this.recording === true) {
          return
        }

        try {
          this.recorder = new window.Recorder()
          this.recorder.record()
          this.recordStatus = '錄音開始'
          this.recording = true
          this.startTimer()
        } catch (e) {
          window.alert(e)
          this.stopAll()
        }
      },

      stopRecording () {
        if (this.recording === false) {
          return
        }

        this.recorder && this.recorder.stop()
        this.recording = false
        this.recordStatus = '錄音結束'
      },

      updateMediaState (data) {
        this.media = data
      },

      createDownloadLink (sent) {
        let self = this
        this.recorder && this.recorder.exportBlob((blob) => {
          let blobUrl = window.URL.createObjectURL(blob)
          let index = self.audioList.map((e) => { return e.name }).indexOf(sent.text)
          let data = {
            name: sent.text,
            url: blobUrl,
            createtime: Date.now()
          }

          index > -1 ? self.audioList[index] = data : self.audioList.push(data)
        }, 'audio/mp3')

        this.recorder.clear()
      },

      voiceRecognition (sent, isShowScore = false) {
        let self = this

        this.recorder && this.recorder.exportBlob((blob) => {
          self.recordStatus = '語音辨識中...'
          api.Ers.Upload(sent.text, blob).then((res) => {
            window.console.log('upload finish: ', res)

            let index = self.audioList.map((e) => { return e.name }).indexOf(sent.text)
            let data = {
              id: res.data.Id,
              name: sent.text,
              url: res.data.AudioUrl,
              createtime: Date.now(),
              score: res.data.Score
            }
            index > -1 ? self.audioList[index] = data : self.audioList.push(data)

            // 上傳錄音檔至Server
            // if (!this.$parent.isDemo) {
            //   api.Lesson.Record.Ers(self.$parent.modules.id, sent.no, res.data)
            //     .then((res) => {
            //       window.console.log('recored updated', res.data)
            //     })
            // }

            if (isShowScore) {
              self.popScore(data.score)
            }
          })
        }, 'audio/wav')

        this.recorder.clear()
      },

      popScore (score) {
        score = score || 0

        this.recordStatus = ''
        let scoreResult = ''

        if (score >= 60 && score < 70) {
          scoreResult = require('../assets/images/pic_emoji_02.png')
        } else if (score >= 70 && score < 80) {
          scoreResult = require('../assets/images/pic_emoji_03.png')
        } else if (score >= 80) {
          scoreResult = require('../assets/images/pic_emoji_04.png')
        } else {
          scoreResult = require('../assets/images/pic_emoji_01.png')
        }

        swal({
          title: '',
          // text: '<div class="text-center"><img src="' + scoreResult + '" /></div>',
          // html: true,
          imageUrl: scoreResult
        })
      },

      removeAllAudio () {
        this.audioList.forEach((audio) => {
          window.URL.revokeObjectURL(audio.url)
        })

        this.audioList = []
      },

      stopAll () {
        this.isRecordAll = false
        this.isRecordSingle = false
        this.playMine = false
        this.recordStatus = ''
        this.currentSentIdx = -1
      },

      recordSingle (sentId) {
        this.stopAll()
        this.isRecordSingle = true

        let self = this
        let action = 0
        let sent = self.data[sentId]
        let start = null
        let step = (timestamp) => {
          start = start === null ? timestamp : start
          let progress = timestamp - start

          if (this.isRecordSingle) {
            switch (action) {
              case 0:
                // 念句子
                if (self.currentSentIdx === sentId && self.media.state === 'stop') {
                  action = action + 1
                  start = timestamp
                } else {
                  self.currentSentIdx = sentId
                  self.recordStatus = '請聆聽句子'
                }
                break
              case 1:
                // 倒數準備錄音
                var waiting = 3 - Math.round(progress / 1000)
                self.recordStatus = '倒數 ' + waiting + '秒 開始錄音'

                if (waiting <= 0) {
                  action = action + 1
                  start = timestamp
                }
                break
              case 2:
                // 錄音
                var limited = Math.round((sent.timeCode_Slow.end - sent.timeCode_Slow.begin) / 1000 * 1.5)
                limited = limited <= 5 ? 5 : limited
                var remainTime = limited - Math.round(progress / 1000)

                self.recordStatus = remainTime + '秒後結束錄音'

                if (!self.recording) {
                  self.startRecording()
                } else if (remainTime <= 0) {
                  self.stopRecording(sent)
                  self.voiceRecognition(sent, self.isRecordSingle)
                  self.timer = 0
                  action = 0
                  self.isRecordSingle = false
                }
                break
            }
            window.requestAnimationFrame(step)
          } else {
            self.stopRecording()
          }
        }

        window.requestAnimationFrame(step)
      },

      recordAll (userRole) {
        this.stopAll()

        if (this.isRecordAll) {
          this.isRecordAll = false
          return false
        } else {
          this.isRecordAll = true
        }

        this.userRole = userRole || null
        let self = this
        let action = 0
        let sentId = 0
        let sent = self.data[sentId]
        let role = sent.name
        let start = null
        let step = (timestamp) => {
          start = start === null ? timestamp : start
          let progress = timestamp - start

          if (this.isRecordAll) {
            switch (action) {
              case 0:
                // 念句子
                if (self.currentSentIdx === sentId && self.media.state === 'stop') {
                  action = action + 1
                  start = timestamp
                } else {
                  self.currentSentIdx = sentId
                  self.recordStatus = '請聆聽原音'
                }
                break
              case 1:
                if (userRole && userRole !== role) {
                  action = 3
                  break
                }

                // 倒數準備錄音
                var waiting = 3 - Math.round(progress / 1000)
                self.recordStatus = '錄音倒數 ' + waiting + '秒'

                if (waiting <= 0) {
                  action = action + 1
                  start = timestamp
                }
                break
              case 2:
                // 錄音
                var limited = Math.round((sent.timeCode_Slow.end - sent.timeCode_Slow.begin) / 1000 * 1.5)
                limited = limited > 5 ? limited : 5
                var remainTime = limited - Math.round(progress / 1000)
                self.recordStatus = remainTime + '秒後結束錄音'

                if (!self.recording) {
                  self.startRecording()
                  self.currentSentIdx = sentId
                } else if (remainTime <= 0) {
                  self.stopRecording(sent)
                  // self.createDownloadLink(sent)
                  self.voiceRecognition(sent)
                  self.timer = 0
                  action = action + 1
                  start = timestamp
                }
                break
              case 3:
                action = 0
                sentId = sentId + 1
                if (sentId < self.data.length) {
                  sent = self.data[sentId]
                  role = sent.name !== '' ? sent.name : role
                } else {
                  self.isRecordAll = false
                }
                break
            }
            window.requestAnimationFrame(step)
          } else {
            self.stopRecording()
            self.stopAll()
          }
        }

        window.requestAnimationFrame(step)
      },

      playMyRoles () {
        this.stopAll()
        let sentId = 0
        let start = null
        let action = 0
        let self = this
        let step = (timestamp) => {
          start = start === null ? timestamp : start

          if (self.playMine) {
            switch (action) {
              case 0:
                if (sentId >= self.data.length) {
                  self.playMine = false
                } else {
                  let index = self.audioList.map((e) => { return e.name }).indexOf(self.data[sentId].text)

                  if (index > -1) {
                    self.playRecord(sentId)
                    self.audio = new window.Audio()
                    action = 2
                  } else {
                    self.playSingle(sentId)
                    action = 1
                  }
                }
                break
              case 1:
                if (self.media.state === 'stop') {
                  action = 0
                  sentId += 1
                }
                break
              case 2:
                if (self.audio === null) {
                  action = 0
                  sentId += 1
                }
                break
            }

            window.requestAnimationFrame(step)
          } else {
            self.$refs.player.pause()
            self.currentSentIdx = -1
          }
        }

        this.playMine = true
        window.requestAnimationFrame(step)
      },

      singleSent (sentId) {
        if (this.isRecordSingle) {
          this.recordSingle(sentId)
        } else {
          this.playSingle(sentId)
        }
      },

      playSingle (sentId) {
        this.audio && this.audio.pause()

        if (this.currentSentIdx === sentId) {
          this.$refs.player.repeatIdx = sentId
          this.$refs.player.times = 1
          this.$refs.player.jumpToSent(this.$refs.player.subtitles[sentId])
          this.$refs.player.play()
        } else {
          this.currentSentIdx = sentId
        }
      },

      playRecord (sentId) {
        let index = this.audioList.map((e) => { return e.name }).indexOf(this.data[sentId].text)
        this.$refs.player.jumpToSent(this.data[sentId])

        if (index > -1) {
          this.media && this.media.state === 'playing' && this.$refs.player.pause()
          this.audio && this.audio.pause()

          let self = this
          api.Ers.Result(this.audioList[index].id)
            .then((res) => {
              self.audio = new window.Audio(res.data.AudioUrl)
              self.audio.onended = () => {
                self.audio = null
              }
              self.audio.play()
            })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/style/app.scss';

  .btn {
    color: #000;
    background-color: transparent;
    padding: 5px;

    img {
      padding: 0 3px;
      margin-top: -3px;
    }

    &:focus {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.0)!important;
    }
  }

  .btn-clean {
    border-radius: 30px;

    &.active {
      color: red;
      background-color: white;
      border-color: red;
    }
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: black;
    text-decoration: none;
  }

  #recorder {
    font-weight: 900;
    background-color: #fff;
    border: 1px #ccc solid;
    height: 85px;
  }

  .blink {
    animation-iteration-count: infinite;
    animation-direction: alternate;

    -webkit-animation-name: blink; /* Chrome, Safari, Opera */
    -webkit-animation-duration: 0.7s; /* Chrome, Safari, Opera */
    animation-name: blink;
    animation-duration: 0.7s;
  }

  .ml-auto {
    .btn {
      padding-left: 3px;
      padding-right: 3px;

      &.active {
        color: red;
      }
    }
  }

  /* Chrome, Safari, Opera */
  @-webkit-keyframes blink {
      from { color: red; }
      to { color: transparent; }
  }

  @keyframes blink {
      from { color: red; }
      to { color: transparent; }
  }

  .panel {
    height: 480px;
    border: 1px #ccc solid;
    overflow-y: scroll;
    position: relative;
    border-top: 0;
  }
</style>



// WEBPACK FOOTER //
// Recorder.vue?4c38bbf0